import { pt, enUS, fr, zhCN } from "date-fns/locale";
import i18next from "i18next";

export const getDateLocale = () => {
  const language = i18next.language || window.localStorage.getItem('i18nextLng') || 'pt';
  
  if (language.startsWith("en")) return enUS;
  if (language.startsWith("fr")) return fr;
  if (language.startsWith("zh")) return zhCN;
  
  return pt; // default fallback
};
